import React, { useEffect } from "react";
import logo from './logo.svg';
import AOS from 'aos';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import 'animate.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import 'aos/dist/aos.css';

import Home from "./pages/Home";
import About from "./pages/About"; // create this next
import Contact from "./pages/Contact"; // create this too
import ServicesPage from "./pages/ServicesPage"; // create this too
import EventsPage from "./pages/EventsPage";

// Admin

import Dashboard from './admin/Dashboard';
import ProtectedRoute from './admin/ProtectedRoute';
import AdminLogin from './admin/AdminLogin';


function App() {
  useEffect(() => {
  AOS.init({ once: true, duration: 800 });
}, []);

  const isAdminPath = window.location.pathname.startsWith('/admin');


  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/service" element={<ServicesPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/admin-login" element={<AdminLogin />} />

        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>      
    </Router>
  );
}

export default App;
